import { render, staticRenderFns } from "./MatchCardTable.vue?vue&type=template&id=9379638e&scoped=true"
import script from "./MatchCardTable.vue?vue&type=script&lang=js"
export * from "./MatchCardTable.vue?vue&type=script&lang=js"
import style0 from "./MatchCardTable.vue?vue&type=style&index=0&id=9379638e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9379638e",
  null
  
)

export default component.exports